import React, { useEffect, useState } from "react";
import JournalMainBanner from "../components/journals/JournalMainBanner";
import AakashgangaHeader from "../components/global/HeaderComponent";
import { getJournalDetailById } from "../store/apiCalls/dashboard";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import coin from "../assets/img/icons/coinT.svg";
import Modal from "react-bootstrap/Modal";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { SERVER_URL } from "../config";
import NewsLetter from "../components/global/NewsLetter";
import SubmitArticleModal from "../components/Modal/SubmitArticleModal";
import AakashgangaFooter from "../components/global/FooterComponent";
import { FaHandPointRight } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { GiSevenPointedStar } from "react-icons/gi";
import "../assets/css/AimsAndScope.css";
import copy from "copy-to-clipboard";

const AimsAndScope = () => {
  const params = useParams();
  const location = useLocation();
  const journalName = location?.state?.journalName;
  const { id } = params;
  const navigate = useNavigate();
  const token = localStorage.getItem("usertoken");
  const pageName = location?.state?.pageName;

  const [journalData, setJournalData] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [filteredData, setFilteredData] = useState(specializationOptions);
  const [uploadArticle, setUploadArticle] = useState(false);
  const [activeType, setActiveType] = useState("aims-and-scope");
  const [show, setShow] = useState(false);
  const [showRec, setShowRec] = useState(false);
  const [showAdvertising, setShowAdvertising] = useState(false);
  const [modalPageName, setModalPageName] = useState(pageName);
  const [modalJournalName, setJournalModalName] = useState(journalName);

  const getJournalDetail = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      journal:
        id === "social-sciences"
          ? "Samaj Shastra – The Mega Journal of Social Sciences"
          : id === "business-management"
          ? "Chanakya Shastra – The Mega Journal of Business and Management"
          : id === "medicine"
          ? "Charakh Shastra – The Mega Journal of Medicine"
          : id === "engineering"
          ? "Abhiyantran Shastra – The Mega Journal of Engineering"
          : id === "information-technology"
          ? "Soochna Shastra – The Mega Journal of Information Technology"
          : id === "sciences"
          ? "Vigyan Shastra – The Mega Journal of Sciences"
          : id === "ayurveda-and-yoga"
          ? "AyurYoga Shastra – The Mega Journal of Ayurveda and Yoga"
          : id === "society-institute-university"
          ? "Society Journals – The Society Journal of Sciences"
          : null,
    };
    const response = await getJournalDetailById(headers, params);
    if (response?.status === 200) {
      setJournalData(response?.data?.data);
    }
  };

  useEffect(() => {
    getJournalDetail();
    return;
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = specializationOptions.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    const specSearch = [...filtered];
    setFilteredData(specSearch);
  };

  const toggleSearchDropdown = () => {
    setShowSearchDropdown(!showSearchDropdown);
  };

  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    // Add the "th" suffix to the day
    let daySuffix = "th";
    if (day === 1 || day === 21 || day === 31) {
      daySuffix = "st";
    } else if (day === 2 || day === 22) {
      daySuffix = "nd";
    } else if (day === 3 || day === 23) {
      daySuffix = "rd";
    }

    return ` ${month} ${day},  ${year}`;
  }

  const societyJournal = "Mega Journal";
  const SHARE_URL = `${SERVER_URL}/mega-journals/${id}`;
  const title = `I recommend that you checkout ${modalJournalName}. The process of submission is fully automated and it offers affordable APCs, and a very short turnaround time.`;

  const handleCodeCopy = (e) => {
    copy(SHARE_URL);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "#ffffff");
  };

  return (
    <div>
      <div className="tagbody">
        <AakashgangaHeader />
        <Link to={`/mega-journals/${id}`}>
          {" "}
          <JournalMainBanner
            imgUrl={
              societyJournal === "Society Journal"
                ? journalData?.masthead
                : journalData?.masthead
            }
          />
        </Link>
        <div className="menu-center-part ">
          <div className="journalShadow">
            <div className="ag_menu justify">
              <ul className="ag_menu ag_menuSub justify tagul">
                {societyJournal === "Society Journal" ? null : (
                  <li className="tagli">
                    <a
                      href="#"
                      class="custom-journal taga"
                      onClick={toggleSearchDropdown}
                    >
                      Disciplines{" "}
                      <img
                        src="/assets/images/downarrow.png"
                        alt="Down Arrow"
                      />
                    </a>

                    {showSearchDropdown && (
                      <div className="tagliSubNave">
                        <div className="disciplinesbg">
                          <div class="form-group has-search">
                            <span class="fa fa-search form-control-feedback"></span>
                            <input
                              type="text"
                              class="form-control input30"
                              placeholder="Type to search"
                              value={searchQuery}
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </div>
                          <ul className="disciplinesscroll">
                            {filteredData.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </li>
                )}

                <li className="active tagli custom-journal">
                  <Link
                    to="/open-access"
                    onClick={(e) => handleRedirect(e, "/open-access")}
                    className="custom-journal taga"
                  >
                    OPEN SCIENCE
                  </Link>
                </li>

                {Boolean(journalData?.issnNumber && String(journalData.issnNumber).trim() !== "" && !/^[xX\-\s]+$/.test(String(journalData.issnNumber).trim()) && String(journalData.issnNumber).trim().toUpperCase() !== "NA" && String(journalData.issnNumber).trim().toUpperCase() !== "N/A") && (
                  <li>
                    <a href="javascript:;" class="custom-journal taga">
                      E-ISSN{" "}
                      <span className="colr">
                        {" "}
                        {""}
                        {journalData?.issnNumber}
                      </span>
                    </a>
                  </li>
                )}
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    ABBREVATION{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.abbreviation
                        : journalData?.abbreviation}
                    </span>
                  </a>
                </li>

              </ul>
            </div>
          </div>
          <div className="journalShadow d-none">
            <div className="ag_menu justify">
              <ul className="ag_menu ag_menuSub justify tagul">
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    {/* DISCIPLINE{" "} */}
                    <span className=" text-black text-uppercase" style={{}}>
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.subjectData?.[0]?.subject?.subjectName
                        : journalData?.subjectData?.[0]?.subject?.subjectName}
                    </span>
                  </a>
                </li>
                <li className="active tagli custom-journal">
                  <Link
                    to="/open-access"
                    onClick={(e) => handleRedirect(e, "/open-access")}
                    className="custom-journal taga"
                  >
                    OPEN SCIENCE
                  </Link>
                </li>
                <li>
                  <a
                    href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
                    target="_blank"
                    class="custom-journal taga"
                  >
                    <img
                      style={{
                        width: "100px",
                        maxWidth: "100%",
                        transform: "none",
                      }}
                      src={coin}
                      alt="#"
                    />
                  </a>
                </li>
                {Boolean(journalData?.issnNumber && String(journalData.issnNumber).trim() !== "" && !/^[xX\-\s]+$/.test(String(journalData.issnNumber).trim()) && String(journalData.issnNumber).trim().toUpperCase() !== "NA" && String(journalData.issnNumber).trim().toUpperCase() !== "N/A") && (
                  <li>
                    <a href="javascript:;" class="custom-journal taga">
                      E-ISSN{" "}
                      <span className="colr">
                        {" "}
                        {""}
                        {journalData?.issnNumber}
                      </span>
                    </a>
                  </li>
                )}
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    ABBR{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      {societyJournal === "Society Journal"
                        ? journalData?.abbreviation
                        : journalData?.abbreviation}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="javascript:;" class="custom-journal taga">
                    FIRST PUBLISHED{" "}
                    <span className="colr">
                      {" "}
                      {""}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: formatDate(journalData?.createdAt),
                        }}
                      ></div>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="editorContainer">
            <div className="editorPage">
              <span className="editorHead">Aims and Scope</span>
              <div className="journalBackWrap ">
                <Link to={`/mega-journals/${id}`}>
                  <span>Journal Homepage</span>
                </Link>
                {!token ? (
                  <Link
                    to="/login"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRedirect(e, "/login");
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                ) : (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setUploadArticle(true);
                    }}
                    className="ag_btn_red ag_btn_redclr"
                  >
                    Submit Article
                  </Link>
                )}
              </div>
            </div>
            <div className="bg journals-main-div d-flex">
              <div className="div70 mr-5">
                <p className="pera-text">
                  <b>
                    Chanakya Shastra The Mega Journal of Business and Management
                  </b>{" "}
                  stands as a premier open access platform dedicated to
                  advancing scholarly research and practical insight across all
                  domains of business and management. The journal serves as a
                  bridge between diverse scholarly traditions, promoting
                  interdisciplinary and cross-sectoral collaboration to address
                  the complex challenges facing organizations and societies
                  today.
                </p>
                <p className="my-4 pera-text">
                  Our editorial philosophy emphasizes <b>rigor</b>,{" "}
                  <b>relevance</b>, and
                  <b>reach</b>. We aspire to publish research that not only
                  contributes to academic theory but also holds practical
                  significance for business leaders, policymakers, and
                  entrepreneurs.
                </p>
                <p className="my-4 pera-text">
                  The <b>Editorial Board</b> of Chanakya Shastra is composed of
                  distinguished academicians, practitioners, and thought
                  leaders, ensuring a balanced and global perspective in every
                  publication. The team is committed to nurturing an inclusive
                  research culture that values both established expertise and
                  emerging voices.
                </p>
                <div className="my-4 pera-text">
                  <b>Editorial Principles:</b>
                  <div className="ml-4">
                    <p className="mt-2">
                      <span>
                        <FaHandPointRight color="#BC1C2B" className="mr-2" />
                      </span>
                      <b>Excellence in Scholarship:</b> Upholding the highest
                      standards of peer-reviewed research and intellectual
                      contribution.
                    </p>
                    <p className="mt-2">
                      <span>
                        <FaHandPointRight color="#BC1C2B" className="mr-2" />
                      </span>
                      <b>Integrity and Transparency: </b> Ensuring fairness,
                      accountability, and ethical conduct at every stage of
                      publication.
                    </p>
                    <p className="mt-2">
                      <span>
                        <FaHandPointRight color="#BC1C2B" className="mr-2" />
                      </span>
                      <b>Inclusivity and Access: </b> Encouraging participation
                      from diverse regions, institutions, and backgrounds.
                    </p>
                    <p className="mt-2">
                      <span>
                        <FaHandPointRight color="#BC1C2B" className="mr-2" />
                      </span>
                      <b>Practical Relevance: </b> Bridging the gap between
                      theoretical rigor and business practice.
                    </p>
                    <p className="mt-2">
                      <span>
                        <FaHandPointRight color="#BC1C2B" className="mr-2" />
                      </span>
                      <b>Innovation and Foresight: </b> Supporting research that
                      explores emerging trends, disruptive technologies, and
                      transformative business models.
                    </p>
                  </div>
                  <div className="pere-text">
                    <h2 className="font22 custom-24 tagh2 mt-5">
                      Purpose and Vision
                    </h2>
                    <p className="mt-3">
                      <b>Chanakya Shastra</b> The Mega Journal of Business and
                      Management provides an inclusive, influential platform for
                      the dissemination of high-quality scholarly research.
                      Inspired by Chanakya the eminent scholar and advisor to
                      the Mauryan Empire the journal seeks to combine timeless
                      wisdom with contemporary scholarship to address pressing
                      challenges in business, management, and society.
                    </p>
                    <p className="my-4">The journal aims to:</p>
                    <div className="ml-4">
                      <p>
                        <span>
                          <GoDotFill color="#BC1C2B" className="mr-2" />
                        </span>
                        Advance rigorous and innovative research across all
                        areas of business and management.
                      </p>
                      <p>
                        <span>
                          <GoDotFill color="#BC1C2B" className="mr-2" />
                        </span>
                        Encourage intellectual dialogue that integrates theory,
                        practice, and policy.
                      </p>
                      <p>
                        <span>
                          <GoDotFill color="#BC1C2B" className="mr-2" />
                        </span>
                        Support diversity in scholarship by welcoming
                        contributions from academics, early- career researchers,
                        and first-time authors.
                      </p>
                      <p>
                        <span>
                          <GoDotFill color="#BC1C2B" className="mr-2" />
                        </span>
                        Foster global and interdisciplinary perspectives that
                        shape the future of organizations, markets, and
                        economies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="div30 ">
                <div className="journalslist custom-journalist-class">
                  <div className=" align-items-center">
                    <div className="ag_heading_center_wrap our-partner mt-0 info-custom">
                      <h2 className="tagh2">Information</h2>
                    </div>
                  </div>
                  <ul className="journalInfoList">
                    <li class="custom-li-journal tagli">
                      <Link
                        to={`/mega-journals/${id}`}
                        className={
                          activeType === "description" ? "active" : null
                        }
                        onClick={() => setActiveType("description")}
                      >
                        Description
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="javascript:;"
                        className={
                          activeType === "aims-and-scope" ? "active" : null
                        }
                        onClick={() => {
                          setActiveType("aims-and-scope");
                        }}
                      >
                        Aims and Scope
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to={`/mega-journals/${id}/all-articles`}
                        state={{
                          journalName: journalData?.journalName,
                          journalId: journalData?._id,
                        }}
                        className={
                          activeType === "all-articles" ? "active" : null
                        }
                        onClick={() => setActiveType("all-articles")}
                      >
                        Access Articles
                      </Link>
                    </li>

                    <li class="custom-li-journal tagli">
                      <Link
                        to="javascript:;"
                        className={
                          activeType === "editorial-board" ? "active" : null
                        }
                        onClick={(e) => {
                          setActiveType("editorial-board"),
                            handleRedirect(
                              e,
                              `/mega-journals/${id}/editorial-board`
                            );
                        }}
                      >
                        Editorial Board
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="javascript:void(0);"
                        className={
                          activeType === "publishing-editors" ? "active" : null
                        }
                        onClick={(e) => {
                          setActiveType("publishing-editors"),
                            handleRedirect(
                              e,
                              `/mega-journals/${id}/publishing-editors`
                            );
                        }}
                      >
                        Publishing Editors
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/author-submission-guidelines"
                        target="_blank"
                        className={
                          activeType === "author-guidelines" ? "active" : null
                        }
                      >
                        Author Guidelines
                      </Link>
                    </li>

                    <li class="custom-li-journal tagli">
                      <Link
                        className={
                          activeType === "content-type" ? "active" : null
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("content-type");
                          setShow(true);
                        }}
                      >
                        Content Type
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={activeType === "archives" ? "active" : null}
                        to={`/mega-journals/${id}`}
                        state={{
                          activeType: "archives",
                        }}
                      >
                        Archives
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={activeType === "recommend" ? "active" : null}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("recommend");
                          setShowRec(true);
                          setModalPageName(pageName);
                          setJournalModalName(journalName);
                        }}
                      >
                        Recommend
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/how-we-publish"
                        target="_blank"
                        className={
                          activeType === "publishing-model" ? "active" : null
                        }
                      >
                        How We Publish
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        className={
                          activeType === "advertising" ? "active" : null
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveType("advertising");
                          setShowAdvertising(true);
                        }}
                      >
                        Advertise With Us
                      </Link>
                    </li>
                    <li class="custom-li-journal tagli">
                      <Link
                        to="/journal/get-in-touch"
                        target="_blank"
                        className={
                          activeType === "get-in-touch" ? "active" : null
                        }
                      >
                        Get in Touch
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="journalslist martop-10 main-class-publish">
                  <div className="footer-align-bottom"></div>
                  <h2 className="font22 custom-24 tagh2 text-center">
                    Email Alerts
                  </h2>
                  <Link
                    to="/registration"
                    onClick={(e) => handleRedirect(e, "/registration")}
                    className="ag_btn_red signup-btn-journal taga"
                  >
                    SIGN UP
                  </Link>
                </div>
              </div>
            </div>
            <div className="my-4 pera-text">
              <h2 className="font22 custom-24 tagh2">Scope of the Journal</h2>
              <p className="pera-text mt-2">
                The scope of Chanakya Shastra The Mega Journal of Business and
                Management is broad, interdisciplinary, and global. We welcome
                high- quality contributions in (but not limited to):
              </p>
              <div className="pera-text mt-4 ml-4">
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  General Management and Strategy
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Marketing and Consumer Behaviour
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Finance, Accounting, and Economics
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Operations and Supply Chain Management
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Human Resource Management and Organizational Behaviour
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  International Business and Global Trade
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Business Ethics, Sustainability, and Corporate Social
                  Responsibility
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Information Systems and Technology Management
                </p>
                <p>
                  <span>
                    <FaHandPointRight color="#BC1C2B" className="mr-2" />
                  </span>
                  Business Law, Governance, and Regulations
                </p>
              </div>
              <p className="my-4">
                We also encourage research on emerging trends, disruptive
                technologies, innovative practices, and transformative business
                models that influence the evolution of organizations and
                business ecosystems.
              </p>
            </div>
            <div className="mt-4 pera-text">
              <h2 className="font22 custom-24 tagh2">Types of Contributions</h2>
              <p className="mt-2">
                To ensure comprehensive scholarly dialogue, the journal
                publishes a wide range of article types, including:
              </p>
              <div className="py-3">
                <div className="row g-4">
                  {[
                    {
                      title: "Original Research Articles",
                      description:
                        "Empirical or theoretical studies with novel insights.",
                    },
                    {
                      title: "Review Articles",
                      description: "Critical syntheses of existing literature.",
                    },
                    {
                      title: "Systematic Reviews",
                      description:
                        "Evidence-based evaluations of defined research questions.",
                    },
                    {
                      title: "Methodology Papers",
                      description:
                        "New or refined methods, protocols, or analytical tools.",
                    },
                    {
                      title: "Data Articles",
                      description:
                        "Significant datasets with analyses and interpretations.",
                    },
                    {
                      title: "Case Reports",
                      description:
                        "Detailed examinations of unique or instructive business cases.",
                    },
                    {
                      title: "Perspectives / Opinion Articles",
                      description:
                        "Scholarly viewpoints on emerging or debated issues.",
                    },
                    {
                      title: "Conceptual Articles",
                      description:
                        "Proposals of new theories, models, or frameworks.",
                    },
                    {
                      title: "Commentaries",
                      description:
                        "Critical perspectives on previously published work.",
                    },
                    {
                      title: "Book Reviews",
                      description:
                        "Academic evaluations of recent publications.",
                    },
                    {
                      title: "Conference Papers",
                      description:
                        "Peer-reviewed contributions first presented at academic events.",
                    },
                    {
                      title: "Brief Reports",
                      description:
                        "Concise studies with preliminary but important findings.",
                    },
                  ].map((item, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="article-card d-flex flex-column justify-content-center h-100 p-4 rounded-4">
                        <div className="orange-bar"></div>
                        <h5 className="fw-bold mb-2">{item.title}</h5>
                        <p className="mb-0">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="mt-4 pera-text">
              <h2 className="font22 custom-24 tagh2">
                Editorial Policy and Ethics
              </h2>
              <p className="mt-2">
                Chanakya Shastra The Mega Journal of Business and Management is
                committed to the highest standards of editorial integrity,
                transparency, and fairness, in full alignment with international
                best practices and COPE (Committee on Publication Ethics)
                guidelines.
              </p>
              <div className="my-4 ml-4">
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Peer Review:</b> All submissions undergo rigorous
                  double-anonymous peer review.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Originality & Plagiarism:</b> Only original, unpublished
                  work is considered. Plagiarism detection tools are employed.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Research Ethics:</b> Authors must follow ethical research
                  standards, disclose funding, and provide necessary approvals
                  (e.g., human subjects research).
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Authorship & Contributions:</b> Only those with substantial
                  intellectual contribution are listed as authors. Gift or ghost
                  authorship is prohibited.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Conflicts of Interest:</b> Authors, editors, and reviewers
                  must declare any potential conflicts.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Data Transparency:</b> Authors are encouraged to make data,
                  codes, and materials available for verification and
                  replication.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Corrections & Retractions:</b> The journal maintains clear
                  policies for corrections, retractions, or expressions of
                  concern, consistent with COPE.
                </p>
                <p className="mt-2">
                  <span>
                    <GoDotFill color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Editorial Independence:</b> Publication decisions are based
                  solely on scholarly merit, free from commercial or political
                  influence.
                </p>
              </div>
            </div>
            <div className="mt-4 pera-text">
              <h2 className="font22 custom-24 tagh2">
                Commitment to Open Access and Inclusivity
              </h2>
              <p className="mt-2">
                Chanakya Shastra The Mega Journal of Business and Management is
                a fully open access journal, ensuring free and equitable
                availability of knowledge worldwide. We are committed to:
              </p>
              <div className="my-4 ml-4">
                <p className="mt-2">
                  <span>
                    <GiSevenPointedStar color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>Removing barriers to knowledge dissemination.</b>
                </p>
                <p className="mt-2">
                  <span>
                    <GiSevenPointedStar color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>
                    Valuing contributions regardless of geography, gender, or
                    institutional affiliation.
                  </b>
                </p>
                <p className="mt-2">
                  <span>
                    <GiSevenPointedStar color="#BC1C2B" className="mr-2" />
                  </span>
                  <b>
                    Encouraging global collaboration and dialogue across
                    disciplines.
                  </b>
                </p>
              </div>
              <p>
                Through this vision, Chanakya Shastra The Mega Journal of
                Business and Management aspires to nurture impactful
                scholarship, foster intellectual leadership, and contribute
                meaningfully to the practice and advancement of business and
                management worldwide.
              </p>
            </div>
          </div>
        </div>
        <NewsLetter />
        <SubmitArticleModal
          uploadArticle={uploadArticle}
          setUploadArticle={setUploadArticle}
        />
        <Modal
          show={showAdvertising}
          size="lg"
          backdrop="static"
          keyboard={false}
          centered
          aria-labelledby="contained-modal-title-vcenter markitPopupRecomendBox"
          className="markitPopupRecomendBox"
        >
          <Modal.Header className="justify-content-center closeButtonStyle">
            <Modal.Title className="modal-title pl-0">
              <h2 className="fontsizeshastra ml-2">Advertise With Us</h2>
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowAdvertising(false);
                setActiveType("description");
              }}
              aria-label="Close"
            />
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2">
            <div className="advertisingModal">
              <img src="/assets/images/advertising.png" alt="advertising" />
              <div className="advertisingContent">
                <span className="colorBlack">
                  For advertising inquiries, write to us at
                </span>{" "}
                <a href="mailto:contactus@vikramshilaedu.in">
                  contactus@vikramshilaedu.in
                </a>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={show}
          // onHide={handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter "
          centered
          className="markitPopupBox"
        >
          <Modal.Header
            className="justify-content-center closeButtonStyle"
            closeButton
            onClick={() => setShow(false)}
          >
            <Modal.Title className="modal-title pl-0">
              <h2 className="fontsizemod ml-2">
                Aakashganga currently accepts the following types of research
                articles for publishing
              </h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2">
            <div className="px-2 text-center">
              <p className="f-14">
                <ul className="contentModal">
                  <li className="section">
                    <strong>Original Research:</strong> These are original
                    research studies presenting new findings and insights in any
                    field of science or medicine.
                  </li>
                  <li className="efforts">
                    <strong>Review Articles:</strong> These provide
                    comprehensive and critical reviews of existing research,
                    summarizing and analysing the current state of knowledge on
                    a specific topic.
                  </li>
                  <li className="efforts">
                    <strong>Systematic Review:</strong> A comprehensive and
                    structured method of synthesizing and analyzing existing
                    research studies and evidence on a specific research
                    question or topic.
                  </li>
                  <li className="efforts">
                    <strong>Methodology Articles:</strong> These describe new
                    methods or techniques developed for research or data
                    analysis. Methodology articles focus on the technical
                    aspects of research and often include detailed protocols or
                    algorithms.
                  </li>
                  <li className="efforts">
                    <strong>Data Articles:</strong> These focus primarily on
                    data sets, describing and providing access to large data
                    collections or databases. Data articles may include data
                    descriptions, data analyses, and data visualization.
                  </li>
                  <li className="efforts">
                    <strong>Case Reports:</strong> These describe unique or
                    interesting medical or clinical cases that contribute to the
                    understanding of a particular disease, treatment, or
                    condition.
                  </li>
                  <li className="efforts">
                    <strong>Short Reports:</strong> These are concise research
                    papers presenting new and significant findings but with a
                    shorter format compared to full research articles.
                  </li>
                  <li className="efforts">
                    <strong>Perspectives or Opinions:</strong> These articles
                    express the authors’ perspectives, opinions, or commentaries
                    on a specific scientific, social, or ethical issue.
                  </li>
                  <li className="efforts">
                    <strong>Conceptual Articles:</strong> These articles propose
                    new concepts, frameworks, or theoretical models, often based
                    on existing research or literature.
                  </li>
                  <li className="efforts">
                    <strong>Commentaries:</strong> Commentaries offer critical
                    analysis or perspective on previously published research or
                    current issues within a field.
                  </li>
                  <li className="efforts">
                    <strong>Book Reviews:</strong> These articles evaluate and
                    critique recently published books relevant to the scope of
                    the journal.
                  </li>
                  <li className="efforts">
                    <strong>Conference Papers: </strong>Academics can publish
                    their conference papers on Aakashganga, showcasing original
                    research that unveils new discoveries and insights across
                    the seven Mega Journals on the platform.
                  </li>
                </ul>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-3 pb-3 contactModalFooter"></Modal.Footer>
        </Modal>

        <Modal
          show={showRec}
          onHide={() => setShowRec(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="markitPopupRecomendBox"
        >
          <Modal.Header
            className="justify-content-center closeButtonStyle"
            closeButton
            onClick={() => setActiveType("description")}
          >
            <Modal.Title className="modal-title">
              <h2 className="fontsizeshastra">Recommend {modalPageName}</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2 text-left recommendModalBox">
            <strong>Share it on:</strong>{" "}
            <ul className="ag_ftr_socials contentModal">
              <li>
                <FacebookShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtags={"aakashganga"}
                >
                  <b>
                    <img
                      src="/assets/images/icon-facebook.svg"
                      alt="Facebook Icon"
                    />
                  </b>
                </FacebookShareButton>
              </li>
              <li>
                <TwitterShareButton
                  url={SHARE_URL}
                  title={title}
                  hashtag={"aakashganga"}
                >
                  <b>
                    <img
                      src="/assets/images/icon-twitter.svg"
                      alt="Twitter Icon"
                    />
                  </b>
                </TwitterShareButton>
              </li>
              <li>
                <LinkedinShareButton url={SHARE_URL} title={title}>
                  <b>
                    <img
                      src="/assets/images/icon-linkedIn.svg"
                      alt="LinkedIn Icon"
                    />
                  </b>
                </LinkedinShareButton>
              </li>
            </ul>
            <hr className="journalHr" />
            <strong>Copy Link:</strong>{" "}
            <div className="dis">
              <div class="ag_newsletter_input widrec">
                <input
                  type=""
                  value={SHARE_URL}
                  placeholder="Copy Link"
                ></input>
              </div>
              <a
                href="javascript:;"
                onClick={handleCodeCopy}
                className=" ag_btn_red ag_btn_redclr copy"
              >
                Copy
              </a>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-3 pb-3 contactModalFooter"></Modal.Footer>
        </Modal>
        <AakashgangaFooter />
      </div>
    </div>
  );
};

export default AimsAndScope;
